import { SerializedStyles } from "@emotion/react"
import { MouseEvent } from "react"
import styled from "@emotion/styled"

import SpinnerIcon from "../ui/images/spinner-icon"

const Button = styled.button<{ customStyles?: SerializedStyles }>`
  background: #2ba770;
  border-radius: 5px;
  height: 48px;
  color: #ffffff;
  text-transform: none;
  cursor: pointer;
  border: 0;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  padding: 16px 0px;
  font-family: "Roboto";

  ${(props) => props.customStyles}
`

const FakeButton = styled.div<{ customStyles?: SerializedStyles }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  background: #2ba770;
  border-radius: 5px;
  color: #ffffff;
  border: 0;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  padding: 16px 0px;
  ${(props) => props.customStyles}
`

const DisabledButton = styled.div<{ customStyles?: SerializedStyles }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  background-color: #c2c2c2;
  border-radius: 5px;
  color: #ffffff;
  border: 0;
  ${(props) => props.customStyles}
`

type Props = {
  loading?: boolean
  disabled?: boolean
  type?: "button" | "reset" | "submit" | undefined
  style?: SerializedStyles
  disabledStyle?: SerializedStyles
  loadingStyle?: SerializedStyles
  children: any
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
}

const ButtonCustomV2 = ({
  loading = false,
  disabled = false,
  type = "button",
  style,
  disabledStyle,
  loadingStyle,
  children,
  onClick,
  className
}: Props) => {
  if (loading) {
    return (
      <FakeButton customStyles={loadingStyle}>
        <SpinnerIcon />
      </FakeButton>
    )
  }

  if (disabled) {
    return <DisabledButton customStyles={disabledStyle}>{children}</DisabledButton>
  }

  return (
    <Button type={type} onClick={onClick} className={className} customStyles={style}>
      {children}
    </Button>
  )
}

export default ButtonCustomV2
